import { withProps, StyledElement } from '@udecode/plate';

import { CSSProp } from 'styled-components';
import styles from 'src/shared/styles/richText';

const H1 = withProps(StyledElement, {
  as: 'h1',
  styles: {
    root: styles.h1 as CSSProp,
  },
});

export default H1;
